/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    &.vs {
      fill: ${theme.color.themeTxt};
    }
    &.arrow {
      fill: ${theme.color.primaryBg};
    }
  }
`

export default class ChangeMatchIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="18.618" height="18.567" viewBox="0 0 18.618 18.567" css={Color}>
        <g id="그룹_5368" data-name="그룹 5368" transform="translate(-568.812 -1253.334)">
          <path id="패스_4930" className="vs" data-name="패스 4930" d="M573.311,1265.475h1.943l4.373-5.566h-1.654a.31.31,0,0,0-.164.051.605.605,0,0,0-.159.135l-2.19,2.807a.124.124,0,0,1-.149.039.125.125,0,0,1-.078-.132l.3-2.6a.1.1,0,0,1,0-.055.206.206,0,0,0-.05-.188.282.282,0,0,0-.2-.058H573.96Z" fill="#ddd"/>
          <path id="패스_4931" className="vs" data-name="패스 4931" d="M583.554,1260.415a1.5,1.5,0,0,0-.666-.451,3.064,3.064,0,0,0-1.07-.168h-.005a5.282,5.282,0,0,0-.957.072,2.219,2.219,0,0,0-.694.241,1.7,1.7,0,0,0-.507.435,2.744,2.744,0,0,0-.379.687,1.089,1.089,0,0,0-.1.694,1.106,1.106,0,0,0,.271.472,2.223,2.223,0,0,0,.482.377c.2.115.377.226.543.335a1.47,1.47,0,0,1,.4.37.53.53,0,0,1,.027.563.558.558,0,0,1-.568.344h0a.276.276,0,0,1-.306-.23.88.88,0,0,1,.025-.361l.025-.1c.058-.206.02-.252.02-.252a.31.31,0,0,0-.2-.057h-1.5a2.163,2.163,0,0,0-.157.881,1.215,1.215,0,0,0,.26.7,1.462,1.462,0,0,0,.664.446,3.1,3.1,0,0,0,1.072.164,6.178,6.178,0,0,0,.961-.075,2.155,2.155,0,0,0,.689-.241,1.71,1.71,0,0,0,.5-.435,2.932,2.932,0,0,0,.39-.69,1.029,1.029,0,0,0,.1-.674,1.053,1.053,0,0,0-.273-.468,2.172,2.172,0,0,0-.495-.367c-.2-.113-.386-.223-.558-.332a1.474,1.474,0,0,1-.413-.369.531.531,0,0,1-.022-.572.7.7,0,0,1,.177-.236.592.592,0,0,1,.426-.129h0a.276.276,0,0,1,.311.238v.006a.99.99,0,0,1-.041.386c-.014.036-.022.062-.03.089a.873.873,0,0,1-.046.13c-.016.077.012.094.02.1a.491.491,0,0,0,.216.053h1.5a2.225,2.225,0,0,0,.154-.876A1.2,1.2,0,0,0,583.554,1260.415Z" fill="#ddd"/>
          <path id="패스_4946" className="arrow" data-name="패스 4946" d="M587.38,1261.645l-1.393.144a7.9,7.9,0,0,1-12,7.534l.562-.9a.3.3,0,0,0-.28-.457l-3.03.257a.293.293,0,0,0-.083.019.3.3,0,0,0-.172.388l1.1,2.836a.3.3,0,0,0,.534.051l.627-1a9.3,9.3,0,0,0,14.14-8.87Z" fill="#26aab8"/>
          <path id="패스_4947" className="arrow" data-name="패스 4947" d="M571.722,1257.991a7.9,7.9,0,0,1,10.442-2.134l-.568.909a.3.3,0,0,0,.28.458l3.03-.258a.3.3,0,0,0,.254-.407l-1.1-2.836a.3.3,0,0,0-.534-.051l-.625,1a9.3,9.3,0,0,0-14.041,8.933l1.393-.148A7.841,7.841,0,0,1,571.722,1257.991Z" fill="#26aab8"/>
        </g>
      </svg>
    )
  }
}
